import { makeAutoObservable } from 'mobx';

class AuthStore {
	token: string | null = null;

	constructor() {
		makeAutoObservable(this);

		const savedToken = localStorage.getItem('token');

		if (savedToken) {
			this.token = savedToken;
		}
	}

	setToken(token: string) {
		this.token = token;
		localStorage.setItem('token', token);
	}

	logout() {
		this.token = null;
		localStorage.removeItem('token');
	}

	get isAuthenticated() {
		return !!this.token;
	}
}

const authStore = new AuthStore();

export default authStore;
